import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownTopCombination = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 38, height: 38, viewBox: "0 0 38 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 17L19.0656 21L23 17", stroke: "#434343", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrowDownTopCombination);
export { ForwardRef as ReactComponent };
